<template>
  <b-alert v-if="!value.length" show variant="info" :class="alertClass">
    {{ emptyMessage || 'Nessun elemento trovato' }}
  </b-alert>
  <div v-else class="table table-striped table-hover">
    <div class="thead" v-if="!noHeader">
      <div class="row" v-if="title">
        <div class="col text-center font-weight-bold">{{ title }}</div>
      </div>
      <div class="row py-0" v-if="hasColumnHeaders">
        <template v-for="col in columns">
          <div
            v-if="withDefault(resolveFn(col.show), true)"
            class="font-weight-bold"
            :class="resolveFn(col.class, undefined, undefined) || 'col'"
            :style="resolveFn(col.style, undefined, undefined)">
            <sorter
              :sortable="!!col.sortable"
              :sort="sort"
              :dir="dir"
              :property="col[sortKey]"
              @action="sortBy(col)">{{ col.label }}</sorter>
          </div>
        </template>
      </div>
    </div><!-- .thead -->
    <div class="tbody">
      <template v-for="(item, index) in value">
        <div :class="rowClass">
          <template v-for="col in columns">
            <component
              v-if="withDefault(resolveFn(col.show), true)"
              :class="resolveFn(col.class, item, index) || 'col'"
              :style="resolveFn(col.style, item, index)"
              :is="getRenderer(col)"
              :col="col"
              :item="item"
              :index="index">
            </component>
          </template>
        </div><!-- .row -->
      </template>
    </div><!-- .tbody -->
  </div><!-- .table -->
</template>
<script>
import DefaultColumnRenderer from 'vue-cl/renderers/column/DefaultColumnRenderer';

import ActionsColumnRenderer from 'vue-cl/renderers/column/ActionsColumnRenderer';
import ComponentColumnRenderer from 'vue-cl/renderers/column/ComponentColumnRenderer';
import ConditionsColumnRenderer from 'vue-cl/renderers/column/ConditionsColumnRenderer';
import FilesizeColumnRenderer from 'vue-cl/renderers/column/FilesizeColumnRenderer';
import ProgressColumnRenderer from 'vue-cl/renderers/column/ProgressColumnRenderer';
import RouterLinkColumnRenderer from 'vue-cl/renderers/column/RouterLinkColumnRenderer';
import TimestampColumnRenderer from 'vue-cl/renderers/column/TimestampColumnRenderer';

export const RENDERERS = {
  default: DefaultColumnRenderer,

  actions: ActionsColumnRenderer,
  component: ComponentColumnRenderer,
  conditions: ConditionsColumnRenderer,
  filesize: FilesizeColumnRenderer,
  progress: ProgressColumnRenderer,
  routerlink: RouterLinkColumnRenderer,
  timestamp: TimestampColumnRenderer,
};

export default {
  props: {
    columns: {
      type: Array,
      default: () => []
    },

    value: {
      type: Array,
      default: () => []
    },

    sort: {
      type: String,
      default: undefined
    },

    sortKey: {
      type: String,
      default: 'key'
    },

    dir: {
      type: String,
      default: 'ASC'
    },

    title: {
      type: String,
      default: undefined
    },

    emptyMessage: {
      type: String,
      default: undefined
    },

    noHeader: {
      type: Boolean,
      default: false
    },

    rowClass: {
      default: 'row align-items-center'
    },

    alertClass: {
      
    }
  },

  computed: {
    hasColumnHeaders() {
      for (let c of this.columns) {
        if (c.label) {
          return true;
        }
      }
      return false;
    }
  },

  methods: {
    getRenderer(col) {
      const renderer = RENDERERS[col.type];
      if (renderer) {
        return renderer;
      }
      return RENDERERS.default;
    },

    sortBy(col) {
      this.$emit('sort', col);
    },

    resolveFn(fn, ...args) {
      if (typeof fn === 'function') {
        return fn(...args);
      }

      return fn;
    },

    withDefault(v, def) {
      if (v === undefined) {
        return def;
      }

      return v;
    }
  }
};
</script>
